//
// CSS entry point import
//

import "../scss/style-import.scss"

//
// JS modules import
//

// import "core-js"
import collapsible from "./collapsible"
import Headroom from "headroom.js"
import { tns } from "tiny-slider/src/tiny-slider.module"
import TextScramble from "./scramble"
import autogrow from "./autogrow"
//import video from "./video"
import Plyr from "plyr"
import accordion from "./accordion"
import filterList from "./filter"

//
// Init JS modules
//

// Collapsible
collapsible()

// Headroom - revealing navigation on scroll
const mqList = window.matchMedia("(min-width: 1001px)")
const navMainDemoLink = document.querySelector(".nav-main__request-demo-link")
let isLargeScreen = mqList.matches

if (!isLargeScreen) {
    navMainDemoLink.classList.remove("button--secondary")
    navMainDemoLink.classList.add("button--primary")
}

mqList.addEventListener("change", function () {
    isLargeScreen = mqList.matches
})

const headroom = new Headroom(document.getElementById("header"), {
    onPin: function () {
        if (isLargeScreen) {
            navMainDemoLink.classList.add("button--primary")
            navMainDemoLink.classList.remove("button--secondary")
        }
    },
    onTop: function () {
        if (isLargeScreen) {
            navMainDemoLink.classList.remove("button--primary")
            navMainDemoLink.classList.add("button--secondary")
        }
    },
})
headroom.init()

// Scramble text

const heroHeadingWrappers: NodeListOf<HTMLElement> = document.querySelectorAll(".hero__heading-wrapper")

heroHeadingWrappers.forEach((heroHeadingWrapper) => {
    // This is the original hero heading
    const heroHeading = heroHeadingWrapper.querySelector<HTMLElement>(".hero__heading")
    const heroHeadingHtml = heroHeading.innerHTML

    // Clone of the hero heading, used for measuring (longest keyphrase gets inserted - see below).
    // This heading will be visually hidden using opacity, so it can take up the space needed.
    const measureElement = heroHeadingWrapper.querySelector<HTMLElement>(".js-hero-measure-element")

    // Yet another hero heading clone. This one is the animated heading that is visible to the user.
    // It will be absolutely positioned on top of the measureElement, and styled by the same classes to have it take up as much space as the invisible heading.
    // Both heading clones are kept outside of the heading tag, as a measure to try (no guarantees) to avoid Google from showing scrambled text in the SERPs.
    const animationElement = heroHeadingWrapper.querySelector<HTMLElement>(".js-hero-animate-element")
    const heroHeadingKeyphraseElement = heroHeading.querySelector("b")
    const heroHeadingScrambleWords = heroHeading.dataset.jsScrambleWords

    if (!heroHeadingKeyphraseElement || !heroHeadingScrambleWords) return

    measureElement.innerHTML = heroHeadingHtml
    animationElement.innerHTML = heroHeadingHtml

    // We're not using the original heading for display, but we still want it to be announced to assistive technology. And also leave it there for Google to pick it up.
    heroHeading.classList.add("h-visually-hidden")

    const measureKeyphraseElement = measureElement.querySelector("b")
    const animationKeyphraseElement = animationElement.querySelector("b")
    const heroHeadingKeyphrase = heroHeadingKeyphraseElement.innerText
    const scrambleWords = heroHeadingKeyphrase ? `${heroHeadingScrambleWords}|${heroHeadingKeyphrase}` : heroHeadingScrambleWords
    const phrases = scrambleWords.split("|")
    const longestPhrase = phrases.reduce((p, c) => (p.length > c.length ? p : c))

    // The measure element needs to reserve the largest needed space, using the longest keyphrase found.
    measureKeyphraseElement.innerText = longestPhrase

    // Init the animation effect
    const fx = new TextScramble(animationKeyphraseElement)
    let counter = 0

    const next = () => {
        fx.setText(phrases[counter]).then(() => {
            setTimeout(next, 1500)
        })
        counter = (counter + 1) % phrases.length
    }
    next()
})

// Carousel

const defaultCarouselConfig = {
    preventScrollOnTouch: "auto",
    navPosition: "bottom",
    slideBy: 1,
    responsive: {
        "0": {
            items: 1.3,
            gutter: 24,
            controls: false,
        },
        "768": {
            items: 2.3,
            gutter: 30,
            nav: false,
            controls: true,
        },
        "1001": {
            items: 3.3,
            gutter: 40,
        },
    },
    autoplay: false,
    loop: false,
}

const carouselSelector = ".GridColumnLayer.js-carousel" // Note: Col classes are applied on both grid cols & grid column layers.
const fullWidthCarouselSelector = ".GridColumnLayer.js-carousel--full-width"
const validCarouselItems = ".banner, .hero"

// Transforms carousel markup to allow for easier handling of carousel creation in the CMS

function prepareCarousel(carousel: Element, hideOverflow = false): HTMLElement {
    const carouselClasses = carousel.className
    carousel.className = `carousel ${hideOverflow ? "h-overflow-hidden" : ""}`
    const carouselItemsNode = document.createElement("div")
    carouselItemsNode.className = carouselClasses
    const carouselItems = carousel.querySelectorAll(validCarouselItems)

    if (carouselItems.length === 0) return

    carouselItems[0].insertAdjacentElement("beforebegin", carouselItemsNode)

    carouselItems.forEach((item) => {
        // NOTE: Looks a bit strange, but we need a couple of wrapper elements in order not have to rewrite the styling
        const sliderItem = document.createElement("div")
        const dummy = document.createElement("div")
        dummy.appendChild(item)
        sliderItem.appendChild(dummy)
        carouselItemsNode.appendChild(sliderItem)
    })

    return carouselItemsNode
}

// Regular carousel

if (document.querySelectorAll(carouselSelector).length > 0) {
    document.querySelectorAll(carouselSelector).forEach((carousel) => {
        const carouselItemsNode = prepareCarousel(carousel)

        tns({
            ...defaultCarouselConfig,
            container: carouselItemsNode,
        })
    })
}

// Full width carousel

if (document.querySelectorAll(fullWidthCarouselSelector).length > 0) {
    document.querySelectorAll(fullWidthCarouselSelector).forEach((carousel) => {
        const carouselItemsNode = prepareCarousel(carousel, true)

        tns({
            ...defaultCarouselConfig,
            container: carouselItemsNode,
            items: 1,
            controlsPosition: "bottom",
            responsive: {
                "0": {
                    controls: false,
                },
                "768": {
                    controls: true,
                },
            },
        })
    })
}

// Autogrow

autogrow()

// Video

const players = Array.from(document.querySelectorAll(".video-player")).map((player: HTMLElement) => {
    const defaultPlayerControls = ["play-large", "play", "progress", "current-time", "mute", "volume", "captions", "settings", "airplay", "fullscreen"]
    const shouldAutoplay = player.hasAttribute("data-js-autoplay")
    const shouldPlayOnHover = player.parentElement.hasAttribute("data-js-hover")
    const isHeroVideo = !!player.closest(".grid__col--header-media")

    const newPlayer = new Plyr(player, {
        volume: 0,
        autoplay: shouldAutoplay && !shouldPlayOnHover,
        muted: shouldAutoplay || shouldPlayOnHover,
        fullscreen: { enabled: false },
        controls: isHeroVideo || shouldPlayOnHover ? [] : defaultPlayerControls,
        clickToPlay: isHeroVideo || shouldPlayOnHover ? false : true,
    })

    newPlayer.on("ready", (e) => {
        const playerElement = e.target as HTMLElement
        const playButtonCaption = playerElement.parentElement.getAttribute("data-js-play-button-caption")

        // Note: not sure why we have to force the player to be muted, since "muted" is set on player instantiation.
        if (shouldAutoplay || shouldPlayOnHover) {
            newPlayer.muted = true
        }

        if (!playButtonCaption || isHeroVideo || shouldPlayOnHover) return
        const title = document.createElement("div")
        title.className = "plyr__play-button-caption"
        title.innerText = playButtonCaption
        //playerElement.appendChild(title) // Skip play button caption for now...

        if (!shouldAutoplay && player.hasAttribute("data-js-poster-image")) {
            newPlayer.poster = player.getAttribute("data-js-poster-image")
        }
    })

    return newPlayer
})

Array.from(document.querySelectorAll(".media")).map((item, index) => {
    if (!item.hasAttribute("data-js-hover")) return
    item.addEventListener("mouseenter", () => playVideo(index))
    item.addEventListener("mouseleave", () => pauseVideo(index))
})

function pauseVideo(index: number) {
    console.log()
    players[index].pause()
}

function playVideo(index: number) {
    players[index].play()
}

// Accordion

accordion()

//
// Filter
//

let page = 0

if (window.innerWidth < 481) {
    page = 8
} else {
    page = 18
}

filterList({ page })

//
// Prevent default behavior on links that end with "#"
//

document.addEventListener("click", function (e: Event) {
    const el = e.target as HTMLElement
    const isLinkThatEndsWithHash = el.closest("a[href$='#']")

    if (isLinkThatEndsWithHash) {
        e.preventDefault()
    }
})

//
// Simplifies touch only styling of interactive elements
//

document.querySelectorAll(".touch-enabled").forEach((link) => {
    link.addEventListener("touchstart", function () {
        this.classList.add("touch-enabled--is-touching")
    })
    link.addEventListener("touchend", function () {
        this.classList.remove("touch-enabled--is-touching")
    })
})
